import React, { Component } from "react";

import { IImageAnnotation } from "@formant/core/model/IImageAnnotation";

import { AssetImage } from "../AssetImage";
import { AnnotatedImage } from "./AnnotatedImage";

export interface IImageViewProps {
    src?: string;
    annotations?: IImageAnnotation[];
}

export class ImageView extends Component<IImageViewProps> {
    public render() {
        const { src, annotations } = this.props;
        return annotations ? (
            <AnnotatedImage src={src} annotations={annotations} />
        ) : (
            <AssetImage src={src} />
        );
    }
}
